import { gql } from '@apollo/client';

export const GET_ALL_TEXTS= gql`
    query{
  getAllTexts{
    _id
    PageName
    TextValue
    TextName
  }
}
`;

export const SUB_TEXT_ELEMENT = gql`
subscription {
  SubAddTextElement{
    _id
    PageName
    TextValue
    TextName
  }
}
`;


export const UPDATE_TEXT = gql`
mutation($TextName : String!, $TextValue : String, $PageName : String,){
  updateText(TextName: $TextName, TextValue : $TextValue, PageName : $PageName)
  {
    _id
    TextName
    TextValue
    PageName
  }
}
`;
export const DELETE_TEXT= gql`
mutation($TextName : String!){
  deleteText(TextName: $TextName)
}
`;

export const GET_ALL_NEWS= gql`
query{
  getAllNews{
    _id
    Text
    Title
    NewsDate
    TextForMain
  }
}
`;


export const UPDATE_NEW = gql`
mutation($_id : ID, $Text: String, $Title : String, $NewsDate : String, $TextForMain : String){
  updateNew(_id : $_id, Text: $Text, Title : $Title, NewsDate : $NewsDate, TextForMain : $TextForMain)
  {
    _id
    Text
    Title
    NewsDate
    TextForMain
  }
}
`;

export const DELETE_NEW = gql`
mutation($_id : ID){
  deleteNew(_id : $_id)
  {
    _id
  }
}
`;


export const SUB_NOVAMEN_ELEMENT = gql`
subscription {
  SubAddNovamenElement{
    _id
    Text
    Title
    NewsDate
    TextForMain
  }
}
`;

export const GET_ALL_FAQ_CATEGORIES= gql`
query{
  getAllFAQCategories{
    _id
    Type
    TechnicalName
    Name
    ListNumber
  }
}
`;

export const GET_ALL_FAQ_ELEMENTS = gql`
query{
  getAllFAQElements{
    _id
    Title
    Text
    TechnicalCategoryName
    ListNumber
  }
}
`;



export const UPDATE_FAQ_CATEGORY = gql`
mutation($_id : ID, $TechnicalName: String, $Type : String, $Name : String, $ListNumber : Int){
  updateFAQCategory(_id : $_id, TechnicalName: $TechnicalName, Name : $Name, Type : $Type, ListNumber : $ListNumber)
  {
    _id
    Type
    TechnicalName
    Name
    ListNumber
  }
}
`;


export const UPDATE_FAQ_ELEMENT = gql`
mutation($_id : ID, $Title: String, $Text : String, $TechnicalCategoryName : String, $ListNumber : Int){
  updateFAQElement(_id : $_id, Title: $Title, Text : $Text, TechnicalCategoryName : $TechnicalCategoryName, ListNumber : $ListNumber)
  {
    _id
    Title
    Text
    TechnicalCategoryName
    ListNumber
  }
}
`;

export const DELETE_FAQ_ELEMENT = gql`
mutation($_id : ID){
  deleteFAQElement(_id : $_id)
  {
    _id
  }
}
`;

export const UPDATE_PAGE_WHOLE = gql`
mutation($Address : String!, $allInformation : String){
updatePageWhole(Address: $Address, allInformation : $allInformation)
  {
    _id
    Address
    allInformation
  }
}
`;

export const GET_ONE_PAGE = gql`
query($Address : String!){
  getOnePage(Address : $Address){
    _id
    Address
    allInformation
  }
}
`;

export const TAKE_ACCNUMBER_INFO = gql`
query($TradingAccount: String!){
    TakeAccNumberInfo(TradingAccount : $TradingAccount)}
`;

export const ADD_MONEY_FROM_ADMIN = gql`
mutation($SumInput : String!, $OneTimeCode: String!, $TradingAccount: String!){
    AddMoneyFromAdmin(SumInput : $SumInput, OneTimeCode: $OneTimeCode, TradingAccount: $TradingAccount)
    }
`;